// @flow

import React from "react";

import NameOrEmail from "src/containers/user/NameOrEmail";
import GroupMembersModal from "../../GroupMembersModal";

import type { UsersAndGroups } from "src/types";

import { UsersValue as StyledUsersValue } from "./styles";

type Props = {
  values: Array<UsersAndGroups>,
};

const UsersValue = ({ values }: Props) => {
  return (
    <StyledUsersValue>
      {values.length > 0 && (
        <>
          {values.map((value, index) => {
            return value.type === "user" ? (
              <>
                <NameOrEmail
                  uid={value.uid}
                  key={value.uid}
                  notificationVariant="value"
                />
                {index !== values.length - 1 && <>,&nbsp;</>}
              </>
            ) : (
              <>
                <GroupMembersModal id={value.id ?? 0} />
                {index !== values.length - 1 && <>,&nbsp;</>}
              </>
            );
          })}
        </>
      )}
    </StyledUsersValue>
  );
};

export default UsersValue;
